import ErrorPage from './ErrorPage';
import React from 'react';
import * as PropTypes from 'prop-types';

// eslint-disable-next-line react/require-optimization
export default class ErrorBoundary extends React.Component{
    static getDerivedStateFromError() {
        return {hasError: true};
    }

    state = {hasError: false};

    componentDidCatch(error, errorInfo) {
        this.props.logger?.captureException(error, {
            additionalStack: errorInfo.componentStack,
        });
    }

    render() {
        if (this.state.hasError) return <ErrorPage locale={this.props.locale}/>;

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
    locale: PropTypes.string,
    logger: PropTypes.object,
};
